const EVENTS = {
	DISPLAY_SETS_ADDED: 'event::displaySetService:displaySetsAdded',
	DISPLAY_SETS_CHANGED: 'event::displaySetService:displaySetsChanged',
	DISPLAY_SETS_REMOVED: 'event::displaySetService:displaySetsRemoved',
	DISPLAY_SET_SERIES_METADATA_INVALIDATED: 'event::displaySetService:displaySetSeriesMetadataInvalidated'
};

export default EVENTS;
